// The dashboard's "Getting started" card (components/dashboard/gettingStarted.js), for a company admin (level c) of a
// Company or Private account: three steps, each ticked once the account has one (laravel dashboard/gettingStarted),
// with a button to the page for it; the card is gone once all three are done. Not for the super admin, resellers or
// district managers.
import { MY_LOCATIONS } from './accountType'

// steps: the server's {client, location, guard, duty}; firstGuardId: where "Set up a duty" goes (a guard's duty form);
// myLocations: a Private owner's My locations page
export function gettingStartedSteps(isPrivate, steps, firstGuardId, myLocations) {
	const s = steps || {}
	return [
		isPrivate
			? { key: 'location', label: 'Add a location', done: !!s.location, button: 'Add a location', path: myLocations || MY_LOCATIONS }
			: { key: 'location', label: 'Add a client and their location', done: !!s.location, button: s.client ? 'Add a location' : 'Add a client',
				path: '/clients' },
		{ key: 'guard', label: 'Add a guard', done: !!s.guard, button: 'Add a guard', path: '/guard-edit/null' },
		{ key: 'duty', label: 'Set up a duty', done: !!s.duty, button: 'Set up a duty', path: firstGuardId ? '/duty-edit/g' + firstGuardId : null,
			waiting: firstGuardId ? null : 'Add a guard first' },
	]
}

export function showGettingStarted(level, steps) {
	return level === 'c' && !!steps && !(steps.location && steps.guard && steps.duty)
}
